import React from 'react';

import { useGetStaticAssetUrl } from '@change-corgi/core/react/assets';
import { TranslateHtml } from '@change-corgi/core/react/i18n';
import { Button } from '@change-corgi/design-system-legacy/components/actions';
import { Image } from '@change-corgi/design-system-legacy/components/media';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import type { Props } from '../../shared/types';

import { AmountButton } from './components/AmountButton';
import { useAmountSelector } from './hooks/useAmountSelector';

export const AmountSelector: React.FC<Props> = (props) => {
	const getStaticAssetUrl = useGetStaticAssetUrl();
	const {
		data: { selectedAmount, buttonAmounts, buttonText, displayPayWithText },
		actions: { onClick },
	} = useAmountSelector(props);

	return (
		<Flex sx={{ flexFlow: 'column', gap: 8 }}>
			<Flex sx={{ gap: 8 }}>
				{buttonAmounts.slice(0, 3).map(({ amount, amountLocalized }, index) => {
					return (
						<AmountButton
							key={amount}
							amount={amount}
							amountLocalized={amountLocalized}
							isSelected={amount === selectedAmount.amount}
							onClick={() => {
								onClick({ amount, buttonName: `a${index + 1}` });
							}}
							sx={{ flex: 1 }}
						/>
					);
				})}
			</Flex>
			<Flex sx={{ gap: 8 }}>
				<AmountButton
					data-testid="membership-awareness-amount-button-third"
					amount={buttonAmounts[3].amount}
					amountLocalized={buttonAmounts[3].amountLocalized}
					isSelected={buttonAmounts[3].amount === selectedAmount.amount}
					onClick={() => {
						onClick({ amount: buttonAmounts[3].amount, buttonName: 'a4' });
					}}
					sx={{ flex: 2 }}
				/>
				<AmountButton
					data-testid="membership-awareness-amount-button-other"
					amount={0}
					amountLocalized="0"
					isSelected={selectedAmount.amount === 0}
					onClick={() => {
						onClick({ amount: 0, buttonName: 'other' });
					}}
					sx={{ flex: 3 }}
				/>
			</Flex>
			<Flex>
				<Button
					data-testid="membership-awareness-support-button"
					sx={{ width: '100%' }}
					onClick={() => {
						onClick({ buttonName: 'contribute' });
					}}
				>
					{buttonText}
				</Button>
			</Flex>
			{displayPayWithText && (
				<Box sx={{ textAlign: 'center' }}>
					<Text>
						<TranslateHtml
							value="corgi.membership.awareness.pay_with"
							replacements={{
								paypalImageElement: (
									<Image
										alt="paypal"
										src={getStaticAssetUrl('/membership/paypal.svg')}
										sx={{
											marginBottom: '-4px',
											display: 'inline',
										}}
									/>
								),
							}}
						/>
					</Text>
				</Box>
			)}
		</Flex>
	);
};
